import {SizeProp} from '@fortawesome/fontawesome-svg-core';
import {ChangeEventHandler} from 'react';
import styled from 'styled-components';

import Luiv3Constants, {LuiV3ColorName} from './constants';
import FaIcon from './FaIcon';

interface Props {
  checked?: boolean;
  color?: LuiV3ColorName;
  size?: SizeProp;
  fontSize?: string;
  disabled?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

const Wrapper = styled.div<{
  fontSize?: string;
  color?: LuiV3ColorName;
  $disabled?: boolean;
}>`
  cursor: ${({$disabled}) => ($disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  position: relative;
  opacity: ${({$disabled}) => ($disabled ? 0.7 : 1)};
  &:has(input:focus-visible) {
    outline: 2px solid
      ${({color = 'blue'}) => Luiv3Constants.baseColor[`${color}-200`]};
    outline-offset: 2px;
    border-radius: 25%;
  }
  ${({fontSize}) => fontSize && `font-size: ${fontSize};`}
`;

const HiddenInput = styled.input.attrs({type: 'checkbox'})`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const FaIconToggle = ({
  checked,
  color = 'blue',
  size,
  fontSize,
  disabled,
  onChange,
}: Props) => {
  return (
    <Wrapper fontSize={fontSize} color={color} $disabled={disabled}>
      <FaIcon
        icon="toggle-on"
        rotate={checked ? undefined : 180}
        faStyle="solid"
        color={checked ? `${color}-500` : `gray-400`}
        size={size}
      />
      <HiddenInput checked={checked} disabled={disabled} onChange={onChange} />
    </Wrapper>
  );
};

export default FaIconToggle;
